class FormControl {
    stateClasses = {
        filled: 'form-control--filled'
    };
    constructor($el) {
        this.$el = $el;

        this.init();
        this.handleState();
    }

    init = () => {
        this.$el.on('change', this.handleState)
    }

    handleState = () => {
        if(this.$el.val() != '') {
            this.$el.addClass(this.stateClasses.filled);
        } else {
            this.$el.removeClass(this.stateClasses.filled);
        }
    }


}

export default FormControl;
